import React, {Component} from 'react';
import {Card, Collapse, Layout} from 'antd';
import {OWN_MOBILITY, TIRES, TIRES_EXCHANGE, WAIT_MOBILITY,} from '../../definition/business';
import {injectIntl} from 'react-intl';
import connect from 'react-redux/es/connect/connect';
import FieldError from '../../../../components/common/input/FieldError';
import MobilityOptions from "../mobility/MobilityOptions";
import AdditionalServices from "./AdditionalServices";
import MainServices from "./MainServices";
import ValueServicesFragment from "./ValueServicesFragment";
import TiresAndWheelsOptions from "./TiresAndWheelsOptions";

const {Panel} = Collapse;

class ServicesMobilityFragment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      extendedOptions: false,
      fetchingBrands: false,
    };
  }

  componentDidMount() {
    if (this.props.selectedMobility && this.props.selectedMobility !== OWN_MOBILITY && this.props.selectedMobility !== WAIT_MOBILITY) {
      this.setState({ extendedOptions: true });
    }
  }

  hasOption = (options, optionId) => !!options.find(o => o.id === optionId);

  render() {
    const {
      intl:{formatMessage},
      otherServices, additionalServices, extraServices,
      showWorkspaceReservations,
      tiresAvailabilities,
      type,
      createAppointmentRequest,
      publicContext
    } = this.props;

    const {selectedOptions} = createAppointmentRequest;
    const tiresExchangeService = otherServices.find(s => s.name === TIRES_EXCHANGE);
    const isNoOptions =
      type === TIRES &&
      !tiresExchangeService &&
      tiresAvailabilities &&
      !tiresAvailabilities.isPitStopWheels &&
      !tiresAvailabilities.isPitStopTires;
    const hideAdditionalServicesSection = additionalServices.length === 0 && extraServices.length === 0;

    let shouldDisplayMobility = publicContext.bookingToken || selectedOptions.length > 0;
    if (type === TIRES) {
      shouldDisplayMobility = shouldDisplayMobility && this.hasOption(selectedOptions, TIRES_EXCHANGE);
    }
    return (
      <Layout style={{ backgroundColor: 'transparent' }}>
        <Card
          title={
            <h2>
              {formatMessage({id: 'customer.journey.step.serviceMobility.serviceTitle'}).toUpperCase()}
            </h2>
          }
          bordered={false}
          style={{ width: '100%', marginBottom: 25 }}
        >
          <div className="wrap">
            <div className="content">
              <p>
                {formatMessage({id: 'customer.journey.step.serviceMobility.servicesAdvise'})}
              </p>
              {!isNoOptions && selectedOptions.length === 0 && (
                <FieldError error={{ message: 'error.min.one.checked' }} />
              )}
              {isNoOptions && (
                <FieldError error={{ message: 'customer.journey.step.serviceMobility.noService' }} />
              )}
              {type === TIRES ? (
                  <TiresAndWheelsOptions/>
              ) : (
                <Collapse bordered={false} defaultActiveKey={['1', '2']}>
                  <Panel header={formatMessage({id: 'customer.journey.step.serviceMobility.mainServices'})} key="1">
                    {publicContext.bookingToken ? <ValueServicesFragment/> : <MainServices/>}
                  </Panel>
                  {!hideAdditionalServicesSection &&
                    <Panel header={formatMessage({id: 'customer.journey.step.serviceMobility.additionalServices'})} key="2">
                    <AdditionalServices/>
                  </Panel>
                  }
                </Collapse>
              )}
            </div>
          </div>
        </Card>
        {shouldDisplayMobility &&
          <MobilityOptions showWorkspaceReservations={showWorkspaceReservations}/>
        }
      </Layout>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  dispatchFetchTireBrands: params =>
    dispatch({ type: 'FETCH.CUSTOMER_DEALER_TIRE_BRAND.REQUEST', params }),
});

const mapStateToProps = state => ({
  mainServices: (state.customerPreJourneyInfo.preJourneyInfo && state.customerPreJourneyInfo.preJourneyInfo.services && state.customerPreJourneyInfo.preJourneyInfo.services.mainServices) || [],
  otherServices: (state.customerPreJourneyInfo.preJourneyInfo && state.customerPreJourneyInfo.preJourneyInfo.services && state.customerPreJourneyInfo.preJourneyInfo.services.otherServices) || [],
  additionalServices: (state.customerPreJourneyInfo.preJourneyInfo && state.customerPreJourneyInfo.preJourneyInfo.services.additionalServices && state.customerPreJourneyInfo.preJourneyInfo.services.additionalServices) || [],
  extraServices: (state.customerPreJourneyInfo.preJourneyInfo && state.customerPreJourneyInfo.preJourneyInfo.services.extraServices && state.customerPreJourneyInfo.preJourneyInfo.services.extraServices) || [],
  tiresAvailabilities: state.availabilities.tiresAvailabilities,
  createAppointmentRequest: state.createAppointmentRequest,
  publicContext: state.publicContext
});

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ServicesMobilityFragment)
);
